import React from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';

export const DataLoader = () => (
  <Box sx={{ p: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
    <CircularProgress size={24} />
    <Typography sx={{ fontSize: 14 }}>Retrieving your data, please wait...</Typography>
  </Box>
);
